import React, { FC, useEffect } from 'react';
import { Table } from '../table/Table';
import { TablesNames } from '../../store/tables/tables-context';
import { Title } from '../developers/page-components/Title';
import { fetchPartnerCommissionsDetails } from '../../store/order/actions/agencies';
import { useParams } from 'react-router-dom';
import { useOrdersContext } from '../../store/order/order-context';

export const PartnerCommissionsDetails: FC = () => {
	const { partnerId } = useParams();
	const { orderContextState: { partnersCommissionsDetails, isPartnersCommissionsDetailsLoading }, dispatch } = useOrdersContext();

	useEffect(() => {
		void fetchPartnerCommissionsDetails(dispatch, partnerId);
	}, []);

	return (
		<div className="mb-10">
			<Table
				name={TablesNames.partnersCommissionsDetailsTableData}
				data={partnersCommissionsDetails}
				isLoading={isPartnersCommissionsDetailsLoading}
				toolbarCustomAction={
					<Title title='Commissions for this capture period' additionalClass='fs-2 ms-2' />
				}
			/>
		</div>
	);
};